import { PopularCitiesContainer } from './PopularCitiesContainer';

export default PopularCitiesContainer;
